import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components/macro';
import { motion, AnimatePresence } from 'framer-motion';
import vw from 'rpf/un/vw';
import Mask from 'components/Mask';

const Wrap = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding: ${vw(30)};
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: ${vw(500)};
  min-width: ${vw(350)};
  height: ${vw(200)};
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: ${vw(12)};
  color: #fff;
  z-index: 100;
  white-space: pre-line;
`;

const Alert = ({ open, text, onClose, closeTime = 1500 }) => {
  const lockRef = useRef();
  useEffect(() => {
    let timeout;
    if (open) {
      if (lockRef.current) return;
      lockRef.current = true;
      timeout = setTimeout(() => {
        lockRef.current = false;
        onClose && onClose();
      }, closeTime);
    }
    return () => {
      lockRef.current = false;
      timeout && clearTimeout(timeout);
    };
  }, [closeTime, onClose, open]);

  return ReactDOM.createPortal(
    <AnimatePresence>
      {open && (
        <Mask
          as={motion.custom(Mask)}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          opacity={0}
        >
          <Wrap>{text}</Wrap>
        </Mask>
      )}
    </AnimatePresence>,
    document.body
  );
};

export default Alert;
